import { render, staticRenderFns } from "./MoreAll.vue?vue&type=template&id=084d6fbe&scoped=true&"
import script from "./MoreAll.vue?vue&type=script&lang=js&"
export * from "./MoreAll.vue?vue&type=script&lang=js&"
import style0 from "./MoreAll.vue?vue&type=style&index=0&id=084d6fbe&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084d6fbe",
  null
  
)

export default component.exports